<template>
  <card>
    <template slot="header">
      <div class="d-flex justify-content-between">
        <h4 class="card-title">Stammdaten</h4>
        <router-link :to="`/products/${product.id}/edit`" class="btn btn-fill btn-primary">
          Bearbeiten
        </router-link>
      </div>
    </template>
    <fg-input label="Name">
      <p class="form-control-static">{{ product.name }}</p>
    </fg-input>
    <fg-input label="Variation von" v-if="product.is_variation_of">
      <p class="form-control-static">
        <router-link :to="`/products/${product.is_variation_of}`">
          {{ product.parent.name }}
        </router-link>
      </p>
    </fg-input>
    <fg-input label="Kurzbezeichnung">
      <p class="form-control-static">{{ product.short_name }}</p>
    </fg-input>
    <fg-input label="Warengruppe">
      <p class="form-control-static">
        {{ product.product_categories ?
          product.product_categories.map(cat => cat.name).join(', ') :
          ''
        }}
      </p>
    </fg-input>
    <div class="row">
      <div class="col-sm-9">
        <fg-input label="Verkaufspreis (brutto)">
          <p class="form-control-static">{{ product.price | priceFromCentEuro }}</p>
        </fg-input>
      </div>
      <div class="col-sm-3">
        <fg-input label="Ust">
          <p class="form-control-static">{{ product.tax | formatTax }}</p>
        </fg-input>
      </div>
    </div>
    <fg-input label="Standard Einkaufspreis (netto)">
      <p class="form-control-static">{{ product.standard_price | priceFromCentEuro }}</p>
    </fg-input>
    <fg-input label="Warnschwelle">
      <p class="form-control-static">{{ product.warnschwelle }}</p>
    </fg-input>
    <fg-input label="Lager Sollmenge">
      <p class="form-control-static">{{ product.lager_soll_menge }}</p>
    </fg-input>
    <fg-input label="Artikelnummer">
      <p class="form-control-static">{{ product.number }}</p>
    </fg-input>
    <fg-input label="Referenznummer">
      <p class="form-control-static">{{ product.referenznummer }}</p>
    </fg-input>
    <fg-input label="Warentarifnummer">
      <p class="form-control-static">{{ product.customs_number }}</p>
    </fg-input>
    <fg-input label="Ist Webshop Produkt">
      <p class="form-control-static">{{ product.is_for_webshop ? 'Ja' : 'Nein' }}</p>
    </fg-input>
    <button class="btn btn-danger btn-fill float-right"
      @click="$emit('deleteProduct')"
    >
      <i class="fa fa-close"></i> Löschen
    </button>
  </card>
</template>

<script>
export default {
  props: ['product']
}
</script>

<style>
</style>
